/** Time sources of the tracker, replaceable in specs. */
export interface ActivityClock {
  /** `performance.timeOrigin + performance.now()` — the unrounded wire `t`. */
  t(): number
  /** `Date.now()`. */
  wall(): number
  /** `performance.now()` — monotonic, for durations. */
  mono(): number
}

export const BROWSER_CLOCK: ActivityClock = {
  t: () => performance.timeOrigin + performance.now(),
  wall: () => Date.now(),
  mono: () => performance.now(),
}
